// WebWorker helper class
var WebWorker = require('./WebWorker.js');

// Your web worker
var renderWorker = require('./renderWorker.js');

var canvases = {};
var queue = [];

const processQueue = (id) => {
  if(queue.length > 0){
    var lastQueue = queue[queue.length - 1];
    queue = [];
      canvases[lastQueue.id].postMessage({
        pattern: lastQueue.pattern, 
        settings: lastQueue.settings
      });
  }
}

const renderClient = (id, pattern, settings, cb) => {

  if('OffscreenCanvas' in window){
    if(canvases[id]){
      
      queue.push({
        id: id,
        pattern: pattern,
        settings: settings,
        cb: cb
      })

      processQueue();

    } else {

      const canvasEl = document.getElementById(id);
      if(!canvasEl) return;

      var offscreenCanvas = canvasEl.transferControlToOffscreen();
      canvases[id] = WebWorker(renderWorker);

      canvases[id].addEventListener("message", e =>{

        processQueue();
        cb(e);        
      });

      // send first message
      canvases[id].postMessage({
        canvas: offscreenCanvas, 
        pattern: pattern, 
        settings: settings
      }, [offscreenCanvas]);
      
    }
  } else {
    renderWorker()({
      data: {
        canvas: document.getElementById(id), 
        pattern: pattern, 
        settings: settings
      }
    });
    cb();
  }

  return;
}

module.exports = renderClient;


// WEBPACK FOOTER //
// ./src/pattern_utilities/renderClient.js